function isObject(data: unknown): data is object {
  return typeof data === 'object' && data !== null;
}

export type ErrorResponse = {
  error: {
    code: string;
    message?: string;
  };
};

/**
 * Function to check if the data is an ErrorResponse.
 *
 * @param data The data to check
 * @returns True if the data is an ErrorResponse
 */
export function isErrorResponse(data: unknown): data is ErrorResponse {
  if (!isObject(data)) {
    return false;
  }
  if (!('error' in data)) {
    return false;
  }
  if (!isObject(data.error)) {
    return false;
  }
  if (!('code' in data.error)) {
    return false;
  }

  return typeof data.error.code === 'string';
}
